module.exports = __webpack_public_path__ + "images/init/not-arranged-empty-17d561286282e8e702e9a6eb1701d615.png";